import { render, staticRenderFns } from "./commitment.vue?vue&type=template&id=5e3ae1a2&scoped=true&"
import script from "./commitment.vue?vue&type=script&lang=js&"
export * from "./commitment.vue?vue&type=script&lang=js&"
import style0 from "./commitment.vue?vue&type=style&index=0&id=5e3ae1a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3ae1a2",
  null
  
)

export default component.exports